import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Eyebrow, Reveal } from "./Reveal";
import { FAQS } from "@/content";

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-[var(--soft)] py-20 lg:py-28">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-5">
          <Eyebrow>FAQs</Eyebrow>
          <h2 data-testid="faq-title" className="headline mt-4 text-4xl sm:text-5xl">Questions?<br />We've got answers.</h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-7">
          <Accordion type="single" collapsible className="w-full border-t border-[var(--ink)]">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`q${i}`} className="border-[var(--line)]">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-head font-bold uppercase text-[15px] tracking-[0.01em] hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${i}`} className="text-[16px] text-[var(--body)] leading-relaxed pb-6 max-w-xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
